import { accessToken } from '../jwtSender';

import { WSTemplatesFetcher } from '@/WebSocket/templates/WSTemplatesFetcher';

import {
  globalObjects,
} from '../../src/dataRequest/mainScript';

const URL_GET_TEMPLATE = getTemplateServiceUrl();

export default async ({
  templateName = '',
  form_desc = false,
  templateHtml = '',
  options = {},
  areaId = '',
  callbackComponent = {},

  successCallback = false,
  errorCallback = () => {},
  progressCallback = false,
  VueLoadingProcess = () => {},
  VueErrorHandler = () => {},
}) => {
  try {
    if (!templateName) throw new Error('Template name is not defined');

    const isInfoOnAreaId = templateName !== 'vehicle_dashboard'

    const { targetSpan: targetElement = {}, button: buttonElement = {} } =
      templateName === 'statistic'
        ? {}
        : objectsListFormColorAndTarget_helper(form_desc);

    if (!targetElement || !buttonElement) return;

    infoShowText_helper(targetElement, `Запрос отправлен...`, isInfoOnAreaId ? areaId : null);
    if (VueLoadingProcess) VueLoadingProcess('Запрос отправлен...');
    setElementColor_helper(buttonElement, 'blue');

    const dataSend = {
      ids: form_desc.objects,
      time_begin: form_desc.beginTime / 1000,
      time_end: form_desc.endTime / 1000,
    };

    dataSend.token = accessToken.value.token;

    dataSend.tzh = 0 - new Date().getTimezoneOffset() / 60;
    
    for (let key in options) {
      dataSend[key] = options[key];
    }

    dataSend.settings = globalObjects.nodeSettings;

    const firstMessage = {
      template_name: templateName,
      body: dataSend,
    };

    const message = JSON.decycle(firstMessage);

    const url = new URL(URL_GET_TEMPLATE);
    url.searchParams.append('roomid', templateName + new Date().getTime());

    const doneHandler = requestDoneHandler({
      templateName,
      successCallback,
      templateHtml,
      targetElement,
      buttonElement,
      areaId,
      callbackComponent,
      options,
    });

    const templatesFetcher = new WSTemplatesFetcher(url, message);

    templatesFetcher.startWS(
      doneHandler,
      errorCallback,
      showMessageHandler(progressCallback, targetElement, areaId, isInfoOnAreaId, VueLoadingProcess),
    );
  } catch (err) {
    console.error(err.message);
    VueErrorHandler(err.message || 'Ошибка получения данных. Выполните новый запрос');
    return errorCallback();
  }
};

const requestDoneHandler = ({
  templateName,
  successCallback,
  templateHtml,
  targetElement,
  buttonElement,
  areaId,
  callbackComponent,
  options,
}) => {
  return (data) => {
    data = JSON.retrocycle(data);
    if (
      [
        'statistic',
        'skillsMan',
        'canIndicators',
        'getCalculated',
        'criticalViolations',
        'getCalculatedWithGeofences',
        'regularMovingGeoTemplate',
        'evacuatorMoving',
      ].includes(templateName)
    ) {
      data.format = formatToDisplay_helper;
    }

    if (successCallback) {
      const params = {
        areaId,
        targetElement,
        buttonElement,
        callbackComponent,
        isGetSmenas: options.isGetSmenas,
      };

      return successCallback(data, params);
    }

    lodashRenderHtmlByTemplateHtml_helper(
      data,
      templateHtml,
      'section-reports',
    );

    infoShowText_helper(
      targetElement,
      'Суммарный отчет построен. Выполнить новый запрос?',
    );
    setElementColor_helper(buttonElement, 'green');

  };
};

const showMessageHandler = (progressCallback, targetElement, areaId, isInfoOnAreaId, VueLoadingProcess) => {
  return (message) => {
    if (progressCallback) return progressCallback(message);
    if (VueLoadingProcess) return VueLoadingProcess(message);

    infoShowText_helper(targetElement, message, isInfoOnAreaId ? areaId : null);
  };
};

function getTemplateServiceUrl() {
  let hostname, protocol, path;

  protocol = window.location.protocol === 'http:' ? 'ws' : 'wss';
  path = process.env.VUE_APP_TEMPLATE_SERVICE_PATH;

  if (process.env.NODE_ENV === 'development') {
    hostname = process.env.VUE_APP_TEMPLATE_DEV_SERVICE_HOSTNAME;
  } else {
    hostname = window.location.hostname;
  }

  return `${protocol}://${hostname}${path}`;
}
